/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Step_1Inputs */

const en_landing_drift_step_1 = /** @type {(inputs: Landing_Drift_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit 1 · label → “late bloom”`)
};

const zh_landing_drift_step_1 = /** @type {(inputs: Landing_Drift_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑 1 · 标签 → “late bloom”`)
};

/**
* | output |
* | --- |
* | "Edit 1 · label → “late bloom”" |
*
* @param {Landing_Drift_Step_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_step_1 = /** @type {((inputs?: Landing_Drift_Step_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Step_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_step_1(inputs)
	return zh_landing_drift_step_1(inputs)
});
export { landing_drift_step_1 as "landing.drift.step_1" }